import axios from 'axios'
import crypto from '@/helpers/crypto'

const API_ENDPOINTS = {
  dev: 'https://dev-api.energocharge.uz/',
  prod: 'https://api.energocharge.uz/'
}

const LOGIN_PATH = '/login'

/**
 * Инициализирует axios с базовыми настройками
 * - Устанавливает baseURL в зависимости от окружения
 * - Настраивает заголовки авторизации
 * - Добавляет interceptor для обработки ошибок 401
 */
export function axiosHandler() {
  // Определяем baseURL автоматически по hostname
  const hostname = window.location.hostname
  let envState = 'prod' // по умолчанию prod
  
  // Проверяем, является ли хост тестовым
  if (hostname.includes('localhost') || 
      hostname.includes('127.0.0.1') || 
      hostname.includes('dev') ||
      hostname === 'dev-admin.energocharge.uz') {
    envState = 'dev'
  }
  
  const baseURL = API_ENDPOINTS[envState] || API_ENDPOINTS.prod
  
  axios.defaults.baseURL = baseURL

  // Настройка заголовков авторизации
  const accessToken = localStorage.getItem('access')
  if (accessToken) {
    try {
      const decryptedToken = crypto.decrypt(accessToken)
      axios.defaults.headers.common['Authorization'] = `Bearer ${decryptedToken}`
      axios.defaults.headers.common['Accept-Language'] = 'ru'
    } catch (error) {
      console.error('Ошибка при расшифровке токена:', error)
      localStorage.removeItem('access')
    }
  }

  // Interceptor для обработки ответов и ошибок
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error?.response?.status
      
      if (status === 401) {
        localStorage.removeItem('access')
        const currentPath = window.location.pathname
        
        if (currentPath !== LOGIN_PATH) {
          window.location.reload()
        }
      }
      
      return Promise.reject(error)
    }
  )
}